import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

import { State } from 'redux/initialState';
import { dateFormat } from 'constants/formats';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import PageWithTabs from 'modules/_shared/components/Pages/PageWithTabs';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';

import { useCommitteeMemberDetails } from './hooks/useCommitteeMemberDetails';
import CommitteeMemberDetailsSummaryTab from './components/CommitteeMemberDetailsSummaryTab';
import CommitteeMemberDetailsPersonalTab from './components/CommitteeMemberDetailsPersonalTab';
import CommitteeMemberDetailsDocumentsTab from './components/CommitteeMemberDetailsDocumentsTab';

const CommitteeMemberDetails = () => {
  const { t } = useTranslate();
  const { data: member, isLoading, isError } = useCommitteeMemberDetails();

  const society = useSelector((state: State) => state.society?.actualSociety);

  const getMemberDescription = () => {
    const startDateText = member?.startDate
      ? format(new Date(member.startDate), dateFormat)
      : '-';

    return `${t('ActiveFrom')}: ${startDateText}`;
  };

  useGetMenu();

  return (
    <Page>
      <PageListHeader
        title={t('CommitteeMember')}
        subTitle={member?.name || '-'}
        subTitleClassName="text-primary fw-normal"
        description={getMemberDescription()}
        actions={[<GoBackButton />]}
      />

      <PageWithTabs
        tabs={[
          {
            key: 'summary-tab',
            icon: 'ni-user-circle',
            title: t('Summary'),
            content: member && (
              <CommitteeMemberDetailsSummaryTab
                member={member}
                society={society}
              />
            ),
          },
          {
            key: 'data-tab',
            icon: 'ni-list',
            title: t('Data'),
            content: member && (
              <CommitteeMemberDetailsPersonalTab member={member} />
            ),
          },
          {
            key: 'documents-tab',
            icon: 'ni-file-text',
            title: t('Documents'),
            content: member && (
              <CommitteeMemberDetailsDocumentsTab
                member={member}
                society={society}
              />
            ),
          },
        ]}
        isError={isError}
        isLoading={isLoading}
      />
    </Page>
  );
};

export default CommitteeMemberDetails;
